module.exports = "../study/imgs/maps/Kanagawa/S8/Ecosystem/PinusPumila/Kanagawa_PinusPumila_MIROC5_RCP45_Mid.png";